import { Reducer } from 'redux';
import { SettingsActionTypes, SettingsState } from './types';

export const initialState: SettingsState = {
  unlinkDBYDResponse: undefined,
  isUnlinkingDBYD: false,
  unlinkDBYDError: undefined,
  updateUserPreferencesResponse: undefined,
  isUpdatingUserPreferences: false,
  updateConfigurationResponse: undefined,
  updateConfigurationError: undefined,
  isUpdatingConfiguration: false,
  configurationUpdateType: undefined,
  setEmailLinkingResponse: undefined,
  isSetEmailLinking: false,
  setEmailLinkingError: undefined
};

const reducer: Reducer<SettingsState> = (state = initialState, action: any) => {
  switch (action.type) {
    case SettingsActionTypes.UNLINK_DBYD_START: {
      return {
        ...state,
        unlinkDBYDResponse: undefined,
        isUnlinkingDBYD: true,
        unlinkDBYDError: undefined
      };
    }
    case SettingsActionTypes.UNLINK_DBYD_SUCCESS: {
      return {
        ...state,
        unlinkDBYDResponse: action.payload,
        isUnlinkingDBYD: false,
        unlinkDBYDError: undefined
      };
    }
    case SettingsActionTypes.UNLINK_DBYD_FAILURE: {
      return {
        ...state,
        unlinkDBYDResponse: undefined,
        isUnlinkingDBYD: false,
        unlinkDBYDError: action.payload
      };
    }
    case SettingsActionTypes.UPDATE_USER_PREFERENCES_START: {
      return {
        ...state,
        updateUserPreferencesResponse: undefined,
        isUpdatingUserPreferences: true
      };
    }
    case SettingsActionTypes.UPDATE_USER_PREFERENCES_SUCCESS: {
      return {
        ...state,
        updateUserPreferencesResponse: action.payload,
        isUpdatingUserPreferences: false
      };
    }
    case SettingsActionTypes.UPDATE_USER_PREFERENCES_FAILURE: {
      return {
        ...state,
        updateUserPreferencesResponse: undefined,
        isUpdatingUserPreferences: false
      };
    }
    case SettingsActionTypes.UPDATE_CONFIGURATION_START: {
      return {
        ...state,
        updateConfigurationResponse: undefined,
        isUpdatingConfiguration: true,
        configurationUpdateType: action.payload.type
      };
    }
    case SettingsActionTypes.UPDATE_CONFIGURATION_SUCCESS: {
      return {
        ...state,
        updateConfigurationResponse: action.payload,
        isUpdatingConfiguration: false
      };
    }
    case SettingsActionTypes.UPDATE_CONFIGURATION_FAILURE: {
      return {
        ...state,
        updateConfigurationResponse: undefined,
        updateConfigurationError: action.payload,
        isUpdatingConfiguration: false
      };
    }
    case SettingsActionTypes.INVALIDATE_PERMALINK_START: {
      return {
        ...state,
        invalidatingPermalink: true,
        isUpdatingConfiguration: true,
        invalidatePermalinkError: undefined
      };
    }
    case SettingsActionTypes.INVALIDATE_PERMALINK_SUCCESS: {
      return {
        ...state,
        invalidatingPermalink: false,
        isUpdatingConfiguration: false
      };
    }
    case SettingsActionTypes.INVALIDATE_PERMALINK_FAILURE: {
      return {
        ...state,
        invalidatingPermalink: false,
        isUpdatingConfiguration: false,
        invalidatePermalinkError: action.payload
      };
    }
    case SettingsActionTypes.SET_EMAIL_LINKING_START: {
      return {
        ...state,
        setEmailLinkingResponse: undefined,
        isSetEmailLinking: true,
        setEmailLinkingError: undefined
      };
    }
    case SettingsActionTypes.SET_EMAIL_LINKING_SUCCESS: {
      return {
        ...state,
        setEmailLinkingResponse: action.payload,
        isSetEmailLinking: false,
        setEmailLinkingError: undefined
      };
    }
    case SettingsActionTypes.SET_EMAIL_LINKING_FAILURE: {
      return {
        ...state,
        setEmailLinkingResponse: undefined,
        isSetEmailLinking: false,
        setEmailLinkingError: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
